import { render, staticRenderFns } from "./DeleteSavedScan.vue?vue&type=template&id=71fb92f2&scoped=true"
import script from "./DeleteSavedScan.vue?vue&type=script&lang=js"
export * from "./DeleteSavedScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb92f2",
  null
  
)

export default component.exports